import React, { useState, useEffect } from "react";
import { googleLogout, useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import constant from "../../constant/app-constant";
import { useDispatch, useSelector } from "react-redux";
import { storeAccessToken, fetchAccessToken } from "../../redux/CartSlice";
import { redirect, useNavigate } from "react-router-dom";
import { auth, googleProvider } from "../../config/firebase";
import {
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signInWithPopup,
} from "firebase/auth";
import "./login.css";
import { db } from "../../config/firebase";
import { getDocs,collection } from "firebase/firestore"; 
import checkUserSignedIn from "../../util/AuthUtil";
import ScrollToTop from "../../components/ScrollToTop";
import Heading from "../../common/Heading";
import Seo from "../../components/Seo";


import { routeMeta } from "../../seo/staticRoutes";
/** Firebase auth codes are not customer-facing English. */
function friendlyAuthError(err) {
  switch (err?.code) {
    case "auth/invalid-credential":
    case "auth/wrong-password":
    case "auth/user-not-found":
      return "That email and password don't match. Please try again.";
    case "auth/email-already-in-use":
      return "An account with this email already exists — try signing in instead.";
    case "auth/invalid-email":
      return "That doesn't look like a valid email address.";
    case "auth/weak-password":
      return "Please choose a password of at least 6 characters.";
    case "auth/too-many-requests":
      return "Too many attempts. Please wait a moment and try again.";
    case "auth/popup-closed-by-user":
    case "auth/cancelled-popup-request":
      return "The Google sign-in window closed before finishing.";
    default:
      return "We couldn't sign you in just now. Please try again, or contact us on WhatsApp.";
  }
}

export default function LoginView() {
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mode, setMode] = useState("signin"); // signin | signup
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [profile, setProfile] = useState(null);
  const [authUser, setAuthUser] = useState(null);
  const navigate = useNavigate();
  const { totalItems } = useSelector((state) => state.cart);


  const productsRef=collection(db,"products")
  // const token = useSelector((state) => state.token);

  // const googleLogin = useGoogleLogin({
  //   onSuccess: (codeResponse) => {
  //     console.log("hgjhjh");
  //     setTokenForStorage(codeResponse);
  //     setUser(codeResponse);
  //   },
  //   onError: (error) => console.log("Login Failed:", error),
  // });


  const googleLogin = async () => {
    setError("");
    setBusy(true);
    try {
      await signInWithPopup(auth, googleProvider);
    } catch (err) {
      console.error(err);
      setError(friendlyAuthError(err));
    } finally {
      setBusy(false);
    }
  };

  /**
   * `mode` decides which Firebase call runs.
   *
   * The single "Sign in" button used to call createUserWithEmailAndPassword —
   * i.e. it always tried to CREATE an account. An existing customer could never
   * sign in with email; they just got "email already in use".
   */
  const login = async () => {
    setError("");

    if (!email.trim() || !password) {
      setError("Please enter your email and password.");
      return;
    }
    if (mode === "signup" && password.length < 6) {
      setError("Please choose a password of at least 6 characters.");
      return;
    }

    setBusy(true);
    try {
      if (mode === "signup") {
        await createUserWithEmailAndPassword(auth, email.trim(), password);
      } else {
        await signInWithEmailAndPassword(auth, email.trim(), password);
      }
    } catch (err) {
      console.error(err);
      setError(friendlyAuthError(err));
    } finally {
      setBusy(false);
    }
  };

  function setTokenForStorage(response) {
    console.log("token", response.access_token);
    dispatch(storeAccessToken(response.access_token));
  }

  // const checkUserSignedIn=()=>{
  //   const listen=onAuthStateChanged(auth,(user)=>{
  //     if(user){
  //       setAuthUser(user)
  //     }
  //     else{
  //       setAuthUser(null)
  //     }
  //   })
  //   return ()=> {
  //     listen();
  //   }
  // }

  useEffect(() => {
  checkUserSignedIn(auth,setAuthUser)

    if (user) {
      axios
        .get(`${constant.BASE_URL}userinfo?access_token=${user.access_token}`, {
          headers: {
            Authorization: `Bearer ${user.access_token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          setProfile(res.data);
        })
        .catch((err) => console.log(err));
    }
  }, [user]);

  useEffect(() => {
  if(authUser)
    totalItems?navigate("/cart"):navigate("/");
},[authUser])

  // log out function to log the user out of google and set the profile array to null
  const logOut = () => {
    googleLogout();
    setProfile(null);
  };

  return (
    <div>
      <Seo {...routeMeta("/login")} />
      <Heading title="Home" subtitle="Login" />
      {profile ? (
        <div>
          <img src={profile.picture} alt="user image" />
          <h3>User Logged in</h3>
          <p>Name: {profile.name}</p>
          <p>Email Address: {profile.email}</p>
          <br />
          <br />
          <button onClick={logOut}>Log out</button>
        </div>
      ) : (
        <div className="nt-auth">
          <div className="nt-auth-shell">
            {/* Brand side — gives the page a reason to exist beyond a form */}
            <aside className="nt-auth-brand">
              <span className="nt-auth-eyebrow">NT Sticks</span>
              <h1>
                {mode === "signup"
                  ? "Create your account"
                  : "Welcome back to the ritual."}
              </h1>
              <p>
                Hand-rolled incense, dhoop and clay idols, made at our family
                workshop in Indore since the day we opened.
              </p>
              <ul className="nt-auth-benefits">
                <li>
                  <i className="fas fa-box-open"></i>
                  Track every order from dispatch to doorstep
                </li>
                <li>
                  <i className="fas fa-bolt"></i>
                  Checkout in seconds — your details are saved
                </li>
                <li>
                  <i className="fas fa-leaf"></i>
                  First to know when a seasonal collection drops
                </li>
              </ul>
            </aside>

            {/* Form side */}
            <div className="nt-auth-form">
              <div className="nt-auth-tabs" role="tablist">
                <button
                  type="button"
                  role="tab"
                  aria-selected={mode === "signin"}
                  className={mode === "signin" ? "is-active" : ""}
                  onClick={() => {
                    setMode("signin");
                    setError("");
                  }}
                >
                  Sign in
                </button>
                <button
                  type="button"
                  role="tab"
                  aria-selected={mode === "signup"}
                  className={mode === "signup" ? "is-active" : ""}
                  onClick={() => {
                    setMode("signup");
                    setError("");
                  }}
                >
                  Create account
                </button>
              </div>

              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  login();
                }}
              >
                <label className="nt-field">
                  <span>Email address</span>
                  <input
                    type="email"
                    value={email}
                    placeholder="you@example.com"
                    autoComplete="email"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </label>

                <label className="nt-field">
                  <span>Password</span>
                  <input
                    type="password"
                    value={password}
                    placeholder={
                      mode === "signup" ? "At least 6 characters" : "Your password"
                    }
                    autoComplete={
                      mode === "signup" ? "new-password" : "current-password"
                    }
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </label>

                {error && (
                  <p className="nt-auth-error" role="alert">
                    {error}
                  </p>
                )}

                <button type="submit" className="nt-auth-primary" disabled={busy}>
                  {busy
                    ? "Please wait…"
                    : mode === "signup"
                    ? "Create account"
                    : "Sign in"}
                </button>

                <div className="nt-auth-divider">
                  <span>or</span>
                </div>

                <button
                  onClick={googleLogin}
                  type="button"
                  className="nt-auth-google"
                  disabled={busy}
                >
                  <img
                    src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                    alt=""
                    aria-hidden="true"
                  />
                  Continue with Google
                </button>
              </form>

              <p className="nt-auth-foot">
                Prefer to order without an account?{" "}
                <a
                  href="https://api.whatsapp.com/send?phone=916264208349"
                  target="_blank"
                  rel="noreferrer"
                >
                  Order on WhatsApp
                </a>
              </p>
            </div>
          </div>
        </div>
      )}

      <ScrollToTop/>
    </div>
  );
}
